
import {aiApi} from './ai'

export const generateTTSApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    
    generateTTS: builder.mutation({
      
      query: ({payload}) => ({
        url: '/generate-tts',
        method: 'POST',
        body: payload,
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useGenerateTTSMutation } = generateTTSApi